import { ButtonBase, Grid, Typography } from "@mui/material";
import { useParams, Link, useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useEffect } from "react";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import posts from "../../Data/post.json";
import { Helmet } from "react-helmet-async";

const Seccion_Solucion_Dinamico = () => {
    const { id } = useParams();
    const { sCell } = useResponsive();
    const navigate = useNavigate();

    const solucion = posts.find(s => s.slug === `/soluciones/${id}/`);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    if (!solucion) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh', pt: 20 }}>
                <Typography variant="h6">Solución no encontrada</Typography>
                <Grid container justifyContent="center" sx={{ mt: 2 }}>
                    <Link to="/servicios/" style={{ textDecoration: 'none', color: '#223B59', fontWeight: 600 }}>
                        Volver a servicios
                    </Link>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            <Helmet>
                <title>{`${solucion.title}`}</title>
                <meta name="description" content={solucion.metaDescripcion} />
                <meta name="keywords" content={solucion.keywords?.join(", ")} />
                <link rel="canonical" href={`https://espaciocompacto.com${solucion.slug}`} />
                <meta property="og:title" content={solucion.titulo} />
                <meta property="og:description" content={solucion.metaDescripcion} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`https://espaciocompacto.com${solucion.slug}`} />
                <meta property="og:image" content={`https://espaciocompacto.com${solucion.imagen}`} />
                <meta property="og:locale" content="es_CO" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={solucion.titulo} />
                <meta name="twitter:description" content={solucion.metaDescripcion} />
                <meta name="twitter:image" content={`https://espaciocompacto.com${solucion.imagen}`} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": solucion.titulo,
                        "description": solucion.metaDescripcion,
                        "image": `https://espaciocompacto.com${solucion.imagen}`,
                        "areaServed": { "@type": "City", "name": "Cali" },
                        "provider": {
                            "@type": "Organization",
                            "name": "Espacio Compacto",
                            "url": "https://espaciocompacto.com"
                        },
                        "url": `https://espaciocompacto.com${solucion.slug}`
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                size={{ xs: 12 }}
                sx={{ pt: 15, pb: 8 }}
            >
                <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{  px: 3 }}
                >
                    {/* Botón volver */}
                    <Grid container size={{ xs: 12 }} sx={{ pb: 4 }}>
                        <ArrowBackIosNewIcon sx={{ color: '#223B59', fontSize: 20, mr: 1 }} />
                        <Typography
                            component={Link}
                            to="/servicios/"
                            sx={{
                                textDecoration: "none",
                                color: '#223B59',
                                fontWeight: "bold",
                                "&:hover": { opacity: 0.7 },
                            }}
                        >
                            Volver a servicios
                        </Typography>
                    </Grid>

                    {/* Header: título + descripción + imagen */}
                    <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        size={{ xs: 12 }}
                        sx={{ borderBottom: '1px solid #223B59', pb: 8, mb: 8, maxWidth:1400}}
                        spacing={4}
                    >
                        {/* Texto izquierda */}
                        <Grid container
                              justifyContent="flex-start"
                              alignItems="flex-start"
                              size={{ xs: 12, sm: 12, md: 7 }}>
                            <Typography
                                component="h1"
                                variant={"h1"}

                            >
                                {solucion.titulo}
                            </Typography>

                            <Typography
                                component="p"
                                variant={"body1"}
                            >
                                {solucion.descripcion}
                            </Typography>

                            <ButtonBase
                                onClick={() => navigate('/contacto/')}
                                sx={{
                                    backgroundColor: '#223B59',
                                    color: '#fff',
                                    px: 3,
                                    py: 1.5,
                                    fontSize: 14,
                                    fontWeight: 600,
                                    borderRadius: 0,
                                    transition: '0.3s',
                                    '&:hover': { backgroundColor: '#1A2F47' },
                                }}
                            >
                                Solicitar Cotización
                            </ButtonBase>
                        </Grid>

                        {/* Imagen derecha */}
                        {!sCell && solucion.imagen && (
                            <Grid container
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                  size={{ xs: 12, sm: 12, md: 5 }}>
                                <img
                                    src={solucion.imagen}
                                    alt={solucion.alt || solucion.titulo}
                                    style={{
                                        width: '100%',
                                        height: '320px',
                                        objectFit: 'cover',
                                    }}
                                />
                            </Grid>
                        )}
                    </Grid>

                    {/* Subservicios */}
                    {solucion.subservicios && solucion.subservicios.length > 0 && (
                        <Grid container size={{ xs: 12 }} spacing={4} sx={{ maxWidth:1400}}>
                            {solucion.subservicios.map((sub, idx) => (
                                <Grid
                                    key={idx}
                                    container
                                    direction="column"
                                    size={{ xs: 12, sm: 6, md: 4 }}
                                >
                                    <Typography
                                        component="h3"
                                        variant={"h3"}
                                        sx={{  }}
                                    >
                                        {sub.titulo}
                                    </Typography>

                                    <Typography
                                        component="p"
                                        variant={"body1"}
                                        sx={{  }}
                                    >
                                        {sub.descripcion}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Solucion_Dinamico;